module.exports = __webpack_public_path__ + "static/media/instructivom6.96f95605.png";